import React, { useState, useRef, useEffect } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import BrowserHistory from '@helpers/BrowserHistory';
import FridayService from '@services/friday';

import * as Cache from '../../../../../helpers/Cache';
import GuardAreaTypeMenu from './GuardAreaTypeMenu';


const EditSafeArea = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const inputRef = useRef(null);
  const [navBtnEnabled, setNavBtnEnabled] = useState(false);
  const [guardAreaType, setGuardAreaType] = useState(-1);
  const [guardAreaLocation, setGuardAreaLocation] = useState('请绘制守护区域');
  const [guardAreaName, setGuardAreaName] = useState('');
  const [showGuardAreaTypeMenu, setShowGuardAreaTypeMenu] = useState(false);

  const title = params.current.actionType === 'add' ? '添加守护区域' : '修改守护区域'
  let rightNavBtnStyle = {};
  if (!navBtnEnabled) {
    rightNavBtnStyle = {background: '#BED6FC'};
  }

  const getGuardTypeText = () => {
    switch(guardAreaType) {
      case 1: return '危险区域';
      case 2: return '安全区域';
      default: return '请输入区域性质';
    }
  }

  const getGuardShapeText = (type: number) => {
    switch(type) {
      case 1: return '圆形守护';
      case 2: return '多边形守护';
      default: return '请绘制守护区域';
    }
  }

  const readGuardAreaNameText = (event: React.FocusEvent<HTMLInputElement>) => {
    setGuardAreaName(event.target.value);
  }

  const onSetGuardAreaLocation = () => {
    FridayService.addEvent('security_guard_add_edit_guard_area_regional_location_click');
    inputRef.current && inputRef.current.blur();
    if (params.current.actionType === 'edit') {
      const item = Cache.get(params.current.uid);
      item.name = guardAreaName;
      item.type = guardAreaType;
      Cache.save(params.current.uid, item);
    } else {
      let item = Cache.get('newGuardArea');
      if (!item) {
        item = {
          uid: '',
          name: guardAreaName,
          type: guardAreaType,
          region: {}
        };
        Cache.save('newGuardArea', item);
      }
    }

    let url = `${PUBLIC_URL}/guardArea?sncode=${params.current.sncode}&company=${params.current.company}&actionType=${params.current.actionType}`;
    if (params.current.actionType === 'edit') {
      url += `&uid=${params.current.uid}`;
    }
    //为了解决在app内安卓手机 输入框弹出后地图按钮无法复位问题
    setTimeout(() => {
      BrowserHistory.push(url);
    }, 200)
  }

  const saveGuardArea = async () => {
    if (params.current.actionType === 'edit') {
      const item = Cache.get(params.current.uid);
      item.name = guardAreaName
      item.type = guardAreaType
      const result = await Http.post(Api.UpdateGuardArea,
        item
      ).catch(e => {
        // nothing
      });

      if(result) {
        BrowserHistory.goBack();
      }
    } else if (params.current.actionType === 'add') {
      const item = Cache.get('newGuardArea');
      const result = await Http.post(Api.AddGuardArea,
        {snCode: params.current.sncode, company: params.current.company, name: guardAreaName, type: guardAreaType, region: item.region}
      ).catch(e => {
        // nothing
      });

      if(result) {
        BrowserHistory.goBack();
      }
    }
  }

  useEffect(() => {
    let item;
    if(params.current.actionType === 'edit') {
      setNavBtnEnabled(true);
      item = Cache.get(params.current.uid);
    } else {
      item = Cache.get('newGuardArea');
    }
    if (item) {
      setGuardAreaName(item.name);
      setGuardAreaType(item.type);
      setGuardAreaLocation(getGuardShapeText(item.region.shape));
    }
  }, []);

  useEffect(() => {
    setNavBtnEnabled(guardAreaName.trim().length > 0 && guardAreaType > 0 && guardAreaLocation !== '请绘制守护区域');
  }, [guardAreaName, guardAreaLocation, guardAreaType]);

  return (
    <div styleName="container">
      <NavBar
        title={title}
        RightBtnComponent={
          <div styleName="nav-right-btn" style={rightNavBtnStyle} onClick={navBtnEnabled ? saveGuardArea : null}>保存</div>
        } />
        <div styleName="list">
          <div className="flex" styleName='item-container top-border'>
            <div className="flex" styleName='item-content'>
              <span styleName='item-title'>区域名称</span>
              <input
                ref={inputRef}
                styleName='input-text'
                placeholder='请输入区域名称'
                maxLength={10}
                defaultValue={guardAreaName}
                onBlur={readGuardAreaNameText}
                onChange={readGuardAreaNameText}
              />
           </div>
            <div styleName='item-sep'/>
          </div>
          <div className="flex" styleName='item-container' onClick={onSetGuardAreaLocation}>
            <div className="flex" styleName='item-content'>
              <span styleName='item-title'>区域位置</span>
              <div className='flex flex-center'>
                <span styleName='item-subtext'>{guardAreaLocation}</span>
                <i styleName='right-arrow' className="iconfont icon-tubiaoyanse"/>
              </div>
           </div>
            <div styleName='item-sep'/>
          </div>
          <div className="flex" styleName='item-container bottom-border' onClick={() => setShowGuardAreaTypeMenu(true)}>
            <div className="flex" styleName='item-content'>
              <span styleName='item-title'>区域性质</span>
              <div className='flex flex-center'>
                <span styleName='item-subtext'>{getGuardTypeText()}</span>
                <i styleName='right-arrow' className="iconfont icon-tubiaoyanse"/>
              </div>
           </div>
          </div>
        </div>
        {
        showGuardAreaTypeMenu ? (
          <GuardAreaTypeMenu
            onClose={ () => setShowGuardAreaTypeMenu(false) }
            onSelect={ (type: number) => setGuardAreaType(type) }
          />
        ) : null
      }
    </div>
  )
}

export default EditSafeArea;
